import styled from "styled-components";

export const FormContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const FormHeader = styled.h2`
  text-align: center;
  color: #333;
`;

export const FormField = styled.div`
  margin-bottom: 15px;
  label {
    display: block;
    font-weight: bold;
  }
  input {
    width: 100%;
    padding: 8px;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  background: #595959;
  color: white;
  border: none;
  cursor: pointer;
`;

export const Message = styled.p`
  text-align: center;
  color: ${({ isError }) => (isError ? "#1a1a1a" : "#595959")};
`;
